import React from "react";
import { Spin } from "antd";
import { IIndexTypeGroupPresenter } from "../../presenter/IndexTypeGroupPresenter";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import IndexTypeGroupGrid from "../components/IndexTypeGroupGrid";

export interface Props extends PageProps {}

export interface State extends IIndexTypeGroupPresenter {}

export default class IndexTypeGroupListPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      createIndexTypeGroup,
      categories,
      indexTypeGroups,
      indexTypes,
      createModalVisible,
      assignItemsModalVisible,
      onChangeAssignItemsModalVisible,
      onChangeCreateModalVisible,
      assignItems,
      onChangeAssignGroupsModalVisible,
      onChangeCreateItemModalVisible,
      assignGroups,
      createItemModalVisible,
      assignGroupsModalVisible,
      currentGroupId,
      currentGroupIndexTypeIds,
      currentGroupChildrenGroupIds,
      createIndexType,
      finishAssigningItems,
      finishAssigningGroups,
      category,
      showGroupDetails,
      updateIndexGroupType,
      deleteIndexGroupType
    } = this.state;

    if (!category) {
      return (
        <Page {...this.props} className={"content-wrapper"}>
          <Spin spinning={true}></Spin>
        </Page>
      );
    }

    return (
      <Page {...this.props} className={"content-wrapper"}>
        {
          <Spin spinning={this.state.loaders.indexTypeGroupsLoader}>
            <IndexTypeGroupGrid
              category={category}
              createModalVisible={createModalVisible}
              assignItemsModalVisible={assignItemsModalVisible}
              onChangeAssignItemsModalVisible={onChangeAssignItemsModalVisible}
              onChangeCreateModalVisible={onChangeCreateModalVisible}
              assignItems={assignItems}
              onChangeAssignGroupsModalVisible={
                onChangeAssignGroupsModalVisible
              }
              onChangeCreateItemModalVisible={onChangeCreateItemModalVisible}
              assignGroups={assignGroups}
              indexTypes={indexTypes}
              translate={translate}
              createIndexTypeGroup={createIndexTypeGroup}
              indexTypeCategories={categories}
              indexTypeGroups={indexTypeGroups}
              referenceLoader={this.state.loaders.indexTypeGroupsLoader}
              createItemModalVisible={createItemModalVisible}
              assignGroupsModalVisible={assignGroupsModalVisible}
              currentGroupId={currentGroupId}
              currentGroupIndexTypes={currentGroupIndexTypeIds}
              currentGroupChildrenGroupIds={currentGroupChildrenGroupIds}
              createIndexType={createIndexType}
              finishAssigningItems={finishAssigningItems}
              finishAssigningGroups={finishAssigningGroups}
              showGroupDetails={showGroupDetails}
              updateIndexGroupType={updateIndexGroupType}
              deleteIndexGroupType={deleteIndexGroupType}
            />
          </Spin>
        }
      </Page>
    );
  }
}
